import { render, staticRenderFns } from "./Widget9.vue?vue&type=template&id=2844612c"
import script from "./Widget9.vue?vue&type=script&lang=js"
export * from "./Widget9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports